'use strict';

const Mn = require('backbone.marionette');
const Context = require('common/domain/value/context');
const GroupRepository = require('common/domain/repository/group');
const GroupRoleRepository = require('common/domain/repository/group-role');
const ProjectRoleRepository = require('common/domain/repository/project-role');
const ProjectRepository = require('common/domain/repository/project');
const TaskUpdateService = require('communication/app/service/task/update');
const Template = require('my/ui/task/item.hbs');


module.exports = Mn.View.extend({
    inCommentTask: false,
    template: Template,
    tagName: 'li',
    className: 'list-item',
    ui: {
        doneButton: '.task-done-button',
    },
    events: {
        'click @ui.doneButton': 'done'
    },
    modelEvents: {
        change: 'render'
    },
    regions: {
        ownerName: '.task-owner-name',
        primaryContext: '.primary-context'
    },

    templateContext: function() {
        return {
            projectName: this.model.getProjectName(),
            projectImageURL: this.model.getProjectImageURL(),
            url: this.model.getTaskURL(),
            isDone: this.model.isDone(),
        }
    },

    onRender: function() {
        const PrimaryContextView = this.getOption('PrimaryContextView');
        if(PrimaryContextView) {
            this.showPrimaryContext();
        }
    },

    showPrimaryContext: function () {
        const context = this.getOption('context');
        const PrimaryContextView = this.getOption('PrimaryContextView');
        const user = context.getUser();
        let project, group;

        ProjectRepository.getProject(this.model.getProjectKey().id)
            .then(p => {
                project = p;
                return GroupRepository.getGroup(project.getGroupId());
            })
            .then(g => {
                group = g;
                const groupMember = group.getMembers().getMemberByUser(user);
                const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                const projectMember = project.getMembers().getMemberByUser(user);
                const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';

                return Promise.all([
                    GroupRoleRepository.find(group).getRole(groupRoleID),
                    ProjectRoleRepository.find(group).getRole(projectRoleID),
                ]);
            })
            .then(values => {
                const groupRole = values[0];
                const projectRole = values[1];
                const projectContext = Context.ProjectContext.build(
                    Context.GroupContext.build(context, group, groupRole),
                    project, projectRole
                );

                this.showChildView('primaryContext', new PrimaryContextView({
                    model: this.model,
                    context: projectContext
                }));
            });
    },

    done: function() {
        ProjectRepository.getProject(this.model.getProjectKey().id)
            .then(project => {
                const taskId = this.model.getTaskKey().id;
                const json = {
                    id: taskId,
                    state: 'done'
                };

                const taskService = new TaskUpdateService(project, taskId, json);
                return taskService.update();
            })
            .then(() => {
                this.model.done();
            });
    }
});



// WEBPACK FOOTER //
// ./my/ui/task/item.js